import { CRM } from './root/CRM';
import { setDefaultOptions } from 'date-fns';

setDefaultOptions({
    weekStartsOn: 1, // Monday
});

const App = () => <CRM />;

export default App;
